#import "../fragments/AutomationFields.graphql"

mutation CreateBroadcast($input: CreateBroadcastInput!) {
  createBroadcast(input: $input) {
    ...AutomationFields
  }
}
